<template>
  <div>
    <div>
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
        <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="keyword"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
        <div style="float: left;">
          <img src="../../../assets/images/32/search.png" @click="SearchData"
               style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
               width="20"
               slot="icon" alt="">
        </div>
      </header>
    </div>
    <div :style="classtest" style="margin-top: 38px">
      <Loadmore :bottom-method="loadBottom" :auto-fill="false" ref="loadmore">
        <Cell style="text-align: left;" v-for="item in ItemList" :key="item.iD" :title="ShowPath(item)"
              v-on:click.native="Details(item)" :is-link="true">
          <img slot="icon" src="../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
          <div v-if="item.zPSL>0">
            <img src="../../../assets/images/16/image.png" width="16" height="16" alt="">
            <span>{{ item.zPSL }}</span>
          </div>
        </Cell>
        <Cell :title="'共计：'+ItemList.length+'个'" v-if="ItemList.length>0"/>
      </Loadmore>
    </div>
    <div>
      <span v-if="noMore">没有更多了...</span>
    </div>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../../../assets/images/no_data.png" alt=""/>
    </div>
  </div>
</template>

<script>
import {Indicator, Loadmore, Cell} from "mint-ui";

export default {
  name: "RegionSearch",
  components: {
    Cell, Loadmore
  },
  data() {
    return {
      showEmptyImage: false,
      noMore: false,
      pageSize: 30,
      pageIndex: 1,
      keyword: null,
      ItemList: [],
      classtest:
          {
            overflow: 'scroll',
            height: (document.documentElement.clientHeight - 60).toString() + 'px',
          },
      token: localStorage.getItem('token'),
      searchRegionUrl: '/api/mzb/searchRegion',
      getRegionDeepUrl: '/api/mzb/getRegionDeep',
    }
  },
  mounted() {
    if (this.$route.params.sigle === undefined) {
      this.$router.go(-1)
    }
  },
  methods: {
    ShowPath(item) {
      if (item.cJ === '1') {
        return item.mC
      } else if (item.cJ === '2') {
        return item.fMC + '>>' + item.mC
      } else if (item.cJ === '3') {
        if (item.fID !== item.dCID)
          return item.dCMC + '>>' + item.fMC + '>>' + item.mC
        else
          return item.fMC + '>>' + item.mC
      }
    },
    SearchData() {
      this.pageIndex = 1
      this.Search(false)
    },
    loadBottom() {
      if (this.noMore === true) {
        this.$refs.loadmore.onBottomLoaded();
        return;
      }
      this.pageIndex++
      this.Search(true)
    },
    Details(item) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getRegionDeepUrl,
        params: {id: item.iD},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          let responseData = response.data['responseData']
          const record_array = [];
          for (let i = 0; i < responseData.length; i++) {
            record_array.push(responseData [i])
          }
          localStorage.setItem('Record_Region_List', JSON.stringify(record_array))
          this.$router.replace({name: 'm_region', params: {isBack: '1'}})
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    Search(isLoadmore) {
      Indicator.open({
        text: '搜索中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.searchRegionUrl,
        params: {keyword: that.keyword, pageIndex: that.pageIndex, pageSize: that.pageSize},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          let responseData = response.data['responseData']
          let list = responseData['data']
          if (that.pageIndex === 1) {
            that.ItemList = list
          } else {
            that.ItemList = that.ItemList.concat(list)
          }
          that.showEmptyImage = that.ItemList.length <= 0;
          that.noMore = that.ItemList.length > 0 && responseData['isLast'].toString() !== 'false';
        }
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
  }
}
</script>

<style lang="less" scoped>
.empty-div {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}

/deep/ .mint-cell-wrapper {
  font-size: 14px;
}
</style>
